import { NgModule } from '@angular/core';
import { SetLoadingStateActive } from './behaviors/set-loading-state-active';
import { SetLoadingStateInactive } from './behaviors/set-loading-state-inactive';
import { HttpGetRequest } from './behaviors/http-get-request';
import { FormatFieldAsEmailOrPhone } from './behaviors/input/format-as-email-or-phone';
import { InputSetLabel } from './behaviors/input/input-set-label';
import { TemplateGoToPage } from './behaviors/template/template-go-to-page';
import { OtpSendCode } from './behaviors/otp/otp-send-code';

import { OtpVerifyCode } from './behaviors/otp/otp-verify-code';
import { OtpVerifySsn } from './behaviors/otp/otp-verify-ssn';
import { IconEditDisabledField } from './behaviors/icon/icon-edit-disabled-field';
import { SaveApplicationBehavior } from './behaviors/application/save-application';
import { SubmitApplicationBehavior } from './behaviors/application/submit-application';
import { SubmitInvoiceBehavior } from './behaviors/application/submit-invoice';
import { TemplateShowNotificationBehavior } from './behaviors/template/template-show-notification';
import { TemplateHideNotificationBehavior } from './behaviors/template/template-hide-notification';

// ApproveMe imports
import { SaveApplicationBehavior as ApproveMeSaveApplication } from './behaviors/approve.me/save-application';
import { SubmitApplicationBehavior as ApproveMeSubmitApplication } from './behaviors/approve.me/submit-application';
import { UpdateApplicationPostApprovalBehavior as ApproveMeUpdateApplicationPostApproval } from './behaviors/approve.me/update-application-post-approval';
import { SendOTPCodeBehavior as ApproveMeSendOtpCode } from './behaviors/approve.me/otp-send-code';
import { OtpUpdatePageState as ApproveMeUpdateOTPPageState } from './behaviors/approve.me/otp-update-page-state';
import { OtpVerifyCodeInputTrigger as ApproveMeOtpVerifyCodeInputTrigger } from './behaviors/approve.me/otp-verify-code-input-trigger';
import { OtpVerifyCode as ApproveMeOtpVerifyCode } from './behaviors/approve.me/otp-verify-code';
import { StartLoaderBehavior } from './behaviors/loader/start-loader';
import { StopLoaderBehavior } from './behaviors/loader/stop-loader';
import { OrderEmailAndPhoneBehavior } from './behaviors/lease-origination-flow/order-email-and-phone';
import { PrepopulateContactInfo } from './behaviors/input/prepopulate-contact-info';
import {
  TrackEventBehavior,
  StartTrackTimeBehavior,
  EndTrackTimeBehavior,
} from './behaviors/analytics/gtm';
import { ShouldShowNextPayDateBehavior } from './conditional-behaviors/should-show-next-paydate';

@NgModule({
  providers: [
    { provide: 'SetLoadingStateActive', useClass: SetLoadingStateActive },
    { provide: 'SetLoadingStateInactive', useClass: SetLoadingStateInactive },
    { provide: 'HttpGetRequest', useClass: HttpGetRequest },
    { provide: 'IconEditDisabledField', useClass: IconEditDisabledField },
    {
      provide: 'FormatFieldAsEmailOrPhone',
      useClass: FormatFieldAsEmailOrPhone,
    },
    { provide: 'InputSetLabel', useClass: InputSetLabel },
    { provide: 'TemplateGoToPage', useClass: TemplateGoToPage },
    {
      provide: 'TemplateShowNotification',
      useClass: TemplateShowNotificationBehavior,
    },
    {
      provide: 'TemplateHideNotification',
      useClass: TemplateHideNotificationBehavior,
    },
    { provide: 'OtpSendCode', useClass: OtpSendCode },
    { provide: 'OtpVerifyCode', useClass: OtpVerifyCode },
    { provide: 'OtpVerifySsn', useClass: OtpVerifySsn },
    // { provide: 'OtpUpdatePageState', useClass: OtpUpdatePageState },
    // { provide: 'OtpUpdateCodeState', useClass: OtpUpdateCodeState },
    { provide: 'SaveApplication', useClass: SaveApplicationBehavior },
    { provide: 'SubmitApplication', useClass: SubmitApplicationBehavior },
    { provide: 'SubmitInvoice', useClass: SubmitInvoiceBehavior },

    { provide: 'StartLoader', useClass: StartLoaderBehavior },
    { provide: 'StopLoader', useClass: StopLoaderBehavior },
    {
      provide: 'PrepopulateContactInfo',
      useClass: PrepopulateContactInfo,
    },
    {
      provide: 'OrderEmailAndPhone',
      useClass: OrderEmailAndPhoneBehavior,
    },
    // Approve.Me specific api behaviors
    {
      provide: 'ApproveMeSaveApplication',
      useClass: ApproveMeSaveApplication,
    },
    {
      provide: 'ApproveMeSubmitApplication',
      useClass: ApproveMeSubmitApplication,
    },
    {
      provide: 'ApproveMeUpdateApplicationPostApproval',
      useClass: ApproveMeUpdateApplicationPostApproval,
    },
    {
      provide: 'ApproveMeSendOtpCode',
      useClass: ApproveMeSendOtpCode,
    },
    {
      provide: 'ApproveMeUpdateOTPPageState',
      useClass: ApproveMeUpdateOTPPageState,
    },
    {
      provide: 'ApproveMeOtpVerifyCodeInputTrigger',
      useClass: ApproveMeOtpVerifyCodeInputTrigger,
    },
    {
      provide: 'ApproveMeOtpVerifyCode',
      useClass: ApproveMeOtpVerifyCode,
    },

    // GTM Behaviors
    {
      provide: 'TrackEvent',
      useClass: TrackEventBehavior,
    },
    {
      provide: 'StartTrackTime',
      useClass: StartTrackTimeBehavior,
    },
    {
      provide: 'EndTrackTime',
      useClass: EndTrackTimeBehavior,
    },
    // ------------
    {
      provide: 'ShouldShowNextPayDate',
      useClass: ShouldShowNextPayDateBehavior,
    },
  ],
})
export class PgBehaviorModule {}
